import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { SettingsService } from '../../services/settings.service';

@Component({
  standalone: false,
  selector: 'ngb-appropriate-use-modal-content',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{title}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross')">
      </button>
    </div>
    <div class="modal-body">
      <p>{{appropriateUsePolicyContent}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" [disabled]="appropriateUsePolicyContent.length < 1" (click)="activeModal.close('Agree')">I Agree</button>
      <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Cancel')">Cancel</button>
    </div>  `
})
export class NgbAppropriateUseModalContent implements OnInit {
  @Input() title;

  public appropriateUsePolicyContent: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private service: SettingsService,
    private cdr: ChangeDetectorRef
    ) { }

  ngOnInit() {
    this.service.getAppropriateUsePolicy().subscribe(
      data  => {
        this.appropriateUsePolicyContent = data.value;
        this.cdr.detectChanges();
        console.log('Appropriate Use Policy Setting retrieved');
        },
      error  => {
        console.log('Error retrieving Appropriate Use Policy', error);
        }
    );
  }

}
